<template>
  <el-dialog
    v-if="visible"
    :visible.sync="visible"
    :title="title"
    show-close
    width="600px"
    :close-on-click-modal="false"
    :before-close="() => $refs.baseForm.cancel()"
    v-el-dialog-drag
    :modal-append-to-body="false"
    :modal="false"
  >
    <baseForm
      ref="baseForm"
      :shipmentCode="shipmentCode"
      :shipmentBookingCodeList="shipmentBookingCodeList"
      :shipmentStatus="shipmentStatus"
      :custCode="custCode"
      @reload="$emit('reload')"
      @close="close()"
    />
    <span slot="footer">
      <el-button size="small" @click="$refs.baseForm.cancel()">
        {{ this.$l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button type="primary" size="small" @click="$refs.baseForm.save()">
        {{ this.$l('INDEX.btn_save') || '保存' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import baseForm from './index.vue'
export default {
  components: { baseForm },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    shipmentCode: { type: String, default: '' },
    shipmentBookingCodeList: { type: Array, default: () => [] },
    shipmentStatus: { type: String, default: '' },
    custCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
